import { format, startOfMonth, endOfMonth, subMonths } from "date-fns";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { todayISO } from "@/lib/api";

const months = Array.from({ length: 12 }, (_, i) => subMonths(new Date(), i));

export function DateRange({ frm, to, onChange, testPrefix = "range" }) {
  const pickMonth = (v) => {
    const d = months[Number(v)];
    onChange(format(startOfMonth(d), "yyyy-MM-dd"), format(i0(v) ? new Date() : endOfMonth(d), "yyyy-MM-dd"));
  };
  return (
    <div className="flex flex-wrap items-end gap-2">
      <div>
        <div className="text-[11px] text-slate-500 mb-1">From</div>
        <Input type="date" value={frm} onChange={(e) => onChange(e.target.value, to)} className="h-9 w-[150px] num" data-testid={`${testPrefix}-from`} />
      </div>
      <div>
        <div className="text-[11px] text-slate-500 mb-1">To</div>
        <Input type="date" value={to} onChange={(e) => onChange(frm, e.target.value)} className="h-9 w-[150px] num" data-testid={`${testPrefix}-to`} />
      </div>
      <Select onValueChange={pickMonth}>
        <SelectTrigger className="h-9 w-[150px]" data-testid={`${testPrefix}-month`}><SelectValue placeholder="Month" /></SelectTrigger>
        <SelectContent>
          {months.map((m, i) => <SelectItem key={i} value={String(i)}>{format(m, "MMMM yyyy")}</SelectItem>)}
        </SelectContent>
      </Select>
      <Button variant="outline" size="sm" className="h-9" onClick={() => onChange(todayISO(), todayISO())} data-testid={`${testPrefix}-today`}>Today</Button>
    </div>
  );
}

const i0 = (v) => Number(v) === 0;
